import {useAuth0} from '@auth0/auth0-react';
import {FunctionComponent, useEffect} from 'react';
import {Helmet} from 'react-helmet';
import {getHotjarHjid, getHotjarHjsv} from '../utils/runtimeVars';

declare global {
  interface Window {
    hj?: (command: string, user_id: string, attrs: {}) => {};
  }
}

const Hotjar: FunctionComponent = () => {
  const hjid = getHotjarHjid();
  const hjsv = getHotjarHjsv();

  const {isAuthenticated, user} = useAuth0();
  const hotjarReady = checkReadyState();

  useEffect(() => {
    if (isAuthenticated && user && checkReadyState()) {
      identify(user.email, user.name, user.sub);
    }
  }, [isAuthenticated, user, hotjarReady]);

  if (!hjid || !hjsv) {
    return null;
  }

  return (
    <Helmet>
      <script id="hotjar" type="text/javascript">{`
        (function(h,o,t,j,a,r){
        h.hj=h.hj||function(){(h.hj.q=h.hj.q||[]).push(arguments)};
        h._hjSettings={hjid:${hjid},hjsv:${hjsv}};
        a=o.getElementsByTagName('head')[0];
        r=o.createElement('script');r.async=1;
        r.src=t+h._hjSettings.hjid+j+h._hjSettings.hjsv;
        a.appendChild(r);
      })(window,document,'https://static.hotjar.com/c/hotjar-','.js?sv=');
      `}</script>
    </Helmet>
  );
};

const identify = (email?: string, name?: string, sub?: string) => {
  if (typeof window.hj === 'function' && email)
    window.hj('identify', email, {
      Name: name || null,
      Subject: sub || null,
      Email: email,
    });
};

const checkReadyState = (): boolean => {
  const hasWindow = typeof window !== 'undefined';
  return !!(hasWindow && window.hj);
};

export default Hotjar;
